import './attachmentModal.scss'

import { READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useEffect } from 'react'

import Icon from '../../../components/Icon/Icon'
import Modal from '../../../components/Modal/Modal';
import ModalContent from '../../../components/Modal/ModalContent';
import t from '../../../helpers/i18n'

const AttachmentModal = ({ onCloseRequested }) => {
  const [[attachModalState], setattachModal] = useVisualState()

  useEffect(() => {
    setattachModal(READY, {})
  }, [setattachModal])

  return (
    <div className='attachment-modal'>
      {attachModalState === READY && (
        <Modal onCloseRequested={onCloseRequested}>
          <ModalContent className='modal-content'>
            <div className='-band'>{t('modal_headers.ATTACHMENTS')}</div>
            <div className='-data-row'>
              <div>
                <img src={'#'} alt='' className='' />
              </div>
              <div className='-document-text'>
                <span className='-document-name'>DOCUMENT NAME</span>
                <span className='-document-type'>JPG Image (254 kb)</span>
              </div>
              <div className='-download-tag'>
                <a href='#pending'>
                  {t('labels.Download')} <Icon size={14} icon='DownloadArrowIcon' />
                </a>
              </div>
            </div>

            <div className='-data-row'>
              <div>
                <img src={'#'} alt='' className='' />
              </div>
              <div className='-document-text'>
                <span className='-document-name'>DOCUMENT NAME</span>
                <span className='-document-type'>JPG Image (254 kb)</span>
              </div>
              <div className='-download-tag'>
                <a href='#pending'>
                  {t('labels.Download')} <Icon size={14} icon='DownloadArrowIcon' />
                </a>
              </div>
            </div>
          </ModalContent>
        </Modal>
      )}
    </div>
  )
}

export default AttachmentModal
